import { CS } from "../../../../base/utils/styler"

export const loadingStyle: CS = {
    padding: '30px',
    direction: 'rtl',
    textAlign: 'center'
}
